// docs/37 — two names for one World. The World's own name is the storyteller's (`world.name`, set
// from the genesis realm when the story is told, LN3); the lobby's name is the keeper's label that
// friends find it by (`world_settings.options.name`, LN1). Lists of lobbies lead with the lobby
// name; everything inside the World says the World's name.
import { display } from './genesis';

/** What the World is called while the storyteller is still writing it (LN6). */
export const UNTOLD = 'A World yet untold';

/** The World's name for display, or the placeholder while its story is unwritten. */
export function worldTitle(world: { name: string } | undefined): string {
  const n = world?.name.trim() ?? '';
  return n ? display(n) : UNTOLD;
}

/** Has the storyteller named this World yet? */
export const isNamed = (world: { name: string } | undefined): boolean => !!world?.name.trim();

/** What a gathering lobby's World is called: it is chosen when the lobby begins (docs/174 LW1). */
export const UNCHOSEN = 'Its World is chosen when it begins';

/** The World's name; unnamed, chosen at Begin while the lobby gathers, else still being written. */
export function worldLine(world: { name: string } | undefined, gathering: boolean): string {
  return isNamed(world) ? worldTitle(world) : gathering ? UNCHOSEN : UNTOLD;
}

/** The lobby's name: the keeper's label, falling back to the World's name for Worlds without one. */
export function lobbyTitle(settings: { options: { name: string } } | undefined, world: { name: string } | undefined): string {
  const n = settings?.options.name.trim() ?? '';
  return n || worldTitle(world);
}
